/* jquery.fancybox.js (v1) expects IE-style style.removeAttribute — not on CSSStyleDeclaration in modern browsers */
(function () {
  try {
    if (typeof CSSStyleDeclaration !== 'undefined' &&
        CSSStyleDeclaration.prototype &&
        typeof CSSStyleDeclaration.prototype.removeAttribute !== 'function') {
      CSSStyleDeclaration.prototype.removeAttribute = function (name) {
        if (name == null || name === '') return;
        try {
          this.removeProperty(String(name));
        } catch (e) {}
      };
    }
  } catch (e) {}
}());

/* Stringing + gift-wrap: same .is-selected pattern as Regular/Hybrid (reliable on old Safari). Label-specific CSS keeps the mark white-on-green. */
(function () {
   function motAddonLabelFromInput(input) {
      if (!input) return null;
      if (typeof input.closest === 'function') {
         var a = input.closest('label.stringing-service-toggle');
         if (a) return a;
         var b = input.closest('label.gift-wrapping-toggle');
         if (b) return b;
         var c = input.closest('label.gift-card-recipient-toggle');
         if (c) return c;
      }
      var p = input.parentNode;
      while (p && p.nodeType === 1) {
         if (p.tagName === 'LABEL') {
            var cn = p.className;
            if (typeof cn === 'string') {
               if (cn.indexOf('stringing-service-toggle') !== -1 || cn.indexOf('gift-wrapping-toggle') !== -1 || cn.indexOf('gift-card-recipient-toggle') !== -1) return p;
            }
         }
         p = p.parentNode;
      }
      return null;
   }
   window.motSyncAddonToggleCheckedLabel = function (input) {
      if (!input) return;
      var lab = motAddonLabelFromInput(input);
      if (!lab) return;
      if (input.checked) {
         if (lab.classList) lab.classList.add('is-selected');
         else if ((lab.className || '').indexOf('is-selected') === -1) {
            lab.className = (lab.className ? lab.className + ' ' : '') + 'is-selected';
         }
         lab.setAttribute('aria-pressed', 'true');
      } else {
         if (lab.classList) lab.classList.remove('is-selected');
         else lab.className = (' ' + (lab.className || '') + ' ').replace(/\s+is-selected\s+/g, ' ').replace(/^\s+|\s+$/g, '');
         lab.setAttribute('aria-pressed', 'false');
      }
   };
}());

$(document).ready(function(){

   $(document).on('change', '#stringservice, #giftwrapservice', function () {
      window.motSyncAddonToggleCheckedLabel(this);
   });
   window.motSyncAddonToggleCheckedLabel(document.getElementById('stringservice'));
   window.motSyncAddonToggleCheckedLabel(document.getElementById('giftwrapservice'));

   /* Build main product item from form (variant id, quantity, properties, selling_plan).
      selling_plan = Shopify subscription/recurring plan ID when product has subscription options. */
   function buildMainItemFromForm(formId) {
      var $form = $('#' + formId);
      var arr = $form.serializeArray();
      var item = { properties: {} };
      for (var i = 0; i < arr.length; i++) {
        var p = arr[i];
        if (p.name === 'id') {
          item.id = parseInt(p.value, 10);
        } else if (p.name === 'quantity') {
          item.quantity = parseInt(p.value, 10) || 1;
        } else if (p.name === 'selling_plan') {
          var sp = parseInt(p.value, 10);
          if (sp > 0) item.selling_plan = sp;
        } else if (p.name.indexOf('properties[') === 0) {
          var key = p.name.replace(/^properties\[|\]$/g, '');
          var val = p.value;
          /* Gift card recipient: omit blank optional Shopify fields (enabled fields only serialize). */
          var gcToggle = document.querySelector('[data-gift-card-recipient] [data-recipient-enable]');
          if (gcToggle && gcToggle.checked && (val === '' || !String(val).trim())) {
            if (key === 'Message' || key === 'Recipient name' || key === 'Send on') continue;
          }
          item.properties[key] = typeof val === 'string' ? val.trim() : val;
        }
      }
      if (!item.id) { var $id = $form.find('[name="id"]'); if ($id.length) item.id = parseInt($id.val(), 10); }
      if (!item.quantity) item.quantity = 1;
      if (Object.keys(item.properties).length === 0) delete item.properties;
      return item;
   }

   /* Build extra items from DOM (gift, promo, cover, gift wrap last for nested cart lines under parent variant). */
   function buildExtrasFromDOM(parentVariantId) {
      var beforeWrap = [];
      var giftWrap = null;
      var qtyEl = document.getElementById("quantity");
      var qty = qtyEl ? parseInt(qtyEl.value, 10) || 1 : 1;
      var pid = parentVariantId ? parseInt(parentVariantId, 10) : 0;
      if (isNaN(pid) || pid <= 0) pid = 0;

      function el(id) { return document.getElementById(id); }
      function withParent(line) {
        if (pid > 0 && line) line.parent_id = pid;
        return line;
      }

      /* Gift with purchase */
      if (el("giftwithpurchase") && el("giftwithpurchase").checked && el("giftwithpurchase_values") && el("gift_id")) {
        beforeWrap.push(withParent({
          quantity: qty,
          id: parseInt(el("giftwithpurchase_values").value, 10),
          properties: { '_Gift ID Depend': el("gift_id").value }
        }));
        if (el("giftwithpurchase_values_2")) {
          beforeWrap.push(withParent({
            quantity: qty,
            id: parseInt(el("giftwithpurchase_values_2").value, 10),
            properties: { '_Gift ID Depend': el("gift_id").value }
          }));
        }
      }

      /* Promo with purchase */
      if (el("promowithpurchase") && el("promowithpurchase").checked && el("promowithpurchase_values") && el("promo_id")) {
        var promoProps = { '_Promo ID Depend': el("promo_id").value };
        if (el("promowithpurchase_values").getAttribute("data-dropship") === 'true') {
          promoProps['Delivery Estimate'] = 'up to 14 business days';
          promoProps['Delivery'] = 'shipped from manufacturer';
        }
        beforeWrap.push(withParent({ quantity: qty, id: parseInt(el("promowithpurchase_values").value, 10), properties: promoProps }));
        if (el("promowithpurchase_values_2")) {
          var promo2Props = { '_Promo ID Depend': el("promo_id").value };
          if (el("promowithpurchase_values_2").getAttribute("data-dropship") === 'true') {
            promo2Props['Delivery Estimate'] = 'up to 14 business days';
            promo2Props['Delivery'] = 'shipped from manufacturer';
          }
          beforeWrap.push(withParent({ quantity: qty, id: parseInt(el("promowithpurchase_values_2").value, 10), properties: promo2Props }));
        }
      }

      /* Cover with purchase (before gift wrap fee so wrap nests last under parent) */
      if (el("coverwithpurchase") && el("coverwithpurchase").checked && el("coverwithpurchase_values") && el("cover_id")) {
        beforeWrap.push(withParent({
          quantity: qty,
          id: parseInt(el("coverwithpurchase_values").value, 10),
          properties: { '_Cover ID Depend': el("cover_id").value }
        }));
      }

      /* Gift wrap service fee — last among add-on lines so it appears under parent after other children */
      if (el("giftwrapservice") && el("giftwrapservice").checked && el("gift_wrapping_id")) {
        var gwProps = { '_Gift Wrapping ID Depend': el("gift_wrapping_id").value };
        if (el('gift_wrap_promo')) { gwProps['_Gift Wrapping Promo'] = 'Free'; }
        giftWrap = withParent({ quantity: qty, id: parseInt(el("giftwrapservice").value, 10), properties: gwProps });
      }

      return { beforeWrap: beforeWrap, giftWrap: giftWrap };
   }

   /* Build stringing items for racquet products (Regular or Hybrid) - returns array to prepend */
   function buildStringingItems() {
      var assign = Object.assign || function(t) { for (var s, i = 1, n = arguments.length; i < n; i++) { s = arguments[i]; for (var k in s) { if (Object.prototype.hasOwnProperty.call(s, k)) t[k] = s[k]; } } return t; };
      var items = [];
      var el = function(id) { return document.getElementById(id); };
      var qtyEl = el("quantity");
      var multEl = el("quantity_multiplier");
      var qty = (parseInt(qtyEl && qtyEl.value, 10) || 1) * (parseInt(multEl && multEl.value, 10) || 1);
      var bundleId = el("bundle_id") && el("bundle_id").value;
      var stringingNote = (el("stringing_note") && el("stringing_note").value) || '';
      var stringType = el("stringservicetype") && el("stringservicetype").value;
      if (!bundleId || !stringType) return items;

      var baseProps = { '_Stringing ID Depend': bundleId, '_ASRC': 'Final Sale' };

      if (stringType === "Regular String" && el("string-options")) {
        var regOpt = el("string-options").options[el("string-options").selectedIndex];
        var regTitle = regOpt && regOpt.title ? String(regOpt.title) : '';
        if (regTitle.indexOf('Customer') === -1) {
          var stringId = parseInt(regTitle, 10);
          if (stringId) {
            items.push({ quantity: qty, id: stringId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
            items.push({ quantity: qty, id: stringId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
          }
        }
      } else if (stringType === "Hybrid String" && el("string-options-main") && el("string-options-cross")) {
        var mainOpt = el("string-options-main").options[el("string-options-main").selectedIndex];
        var crossOpt = el("string-options-cross").options[el("string-options-cross").selectedIndex];
        var crossTitle = crossOpt && crossOpt.title ? String(crossOpt.title) : '';
        var mainTitle = mainOpt && mainOpt.title ? String(mainOpt.title) : '';
        /* Cross before main to match standalone stringing page ordering */
        if (crossTitle.indexOf('Customer') === -1) {
          var crossId = parseInt(crossTitle, 10);
          if (crossId) items.push({ quantity: qty, id: crossId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
        }
        if (mainTitle.indexOf('Customer') === -1) {
          var mainId = parseInt(mainTitle, 10);
          if (mainId) items.push({ quantity: qty, id: mainId, properties: assign({}, baseProps, { 'Unit': 'Half Set' }) });
        }
      } else {
        return items;
      }

      items.push({ quantity: qty, id: 1226716373, properties: { '_Stringing ID Depend': bundleId, 'Stringing Notes': stringingNote, '_ASRC': 'Final Sale' } });
      return items;
   }

   /* Demo racquet: service fee variant – add only once (when no demos/fee in cart yet) */
   var DEMO_SERVICE_FEE_VARIANT_ID = 22430097031;
   function buildDemoItem() {
      return { quantity: 1, id: DEMO_SERVICE_FEE_VARIANT_ID };
   }
   function cartHasDemoServiceFee(cart) {
      if (!cart || !cart.items) return false;
      for (var i = 0; i < cart.items.length; i++) {
        if (cart.items[i].variant_id === DEMO_SERVICE_FEE_VARIANT_ID) return true;
      }
      return false;
   }

   function addItem(form_id, prependItems, clickedElem, maxQtyPerAdd) {
      var mainItem = buildMainItemFromForm(form_id);
      var parentVariantId = mainItem.id;
      var extras = buildExtrasFromDOM(parentVariantId);

      var stringingPrep = (prependItems && prependItems.length) ? prependItems.slice() : [];
      stringingPrep.forEach(function(it) {
        if (it.properties && it.properties['_Stringing ID Depend'] !== undefined) {
          it.parent_id = parentVariantId;
        }
      });

      var items = [mainItem].concat(stringingPrep).concat(extras.beforeWrap);
      if (extras.giftWrap) items.push(extras.giftWrap);
      if (maxQtyPerAdd && maxQtyPerAdd > 0) {
        items.forEach(function(it) { it.quantity = Math.min(parseInt(it.quantity, 10) || 1, maxQtyPerAdd); });
      }
      items.forEach(function(it) { if (it.properties && Object.keys(it.properties).length === 0) delete it.properties; });

      var totalQty = items.reduce(function(sum, it) { return sum + (parseInt(it.quantity, 10) || 1); }, 0);

      var cartAddUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart/add.js') : '/cart/add.js';
      var reqComplete = false;
      $.ajax({
        type: 'POST',
        url: cartAddUrl,
        contentType: 'application/json',
        data: JSON.stringify({ items: items }),
        dataType: 'json',
        success: function(response) {
          reqComplete = true;
          /* Success returns item/line_item; errors have status, message, description (success never has description) */
          var isError = response && (
            response.status === 422 ||
            response.status >= 400 ||
            response.message === 'Cart Error' ||
            (response.description && typeof response.description === 'string' && response.description.length > 0)
          );
          if (isError) {
            Shopify.onError({ responseText: JSON.stringify(response) }, 'error', 'Cart error', clickedElem);
          } else {
            Shopify.onSuccess(response, totalQty, clickedElem);
          }
        },
        error: function(xhr, textStatus, errorThrown) { reqComplete = true; Shopify.onError(xhr, textStatus, errorThrown, clickedElem); }
      });
      window.setTimeout(function() {
        if (!reqComplete && clickedElem && clickedElem.length) {
          reqComplete = true;
          Shopify.onError({ responseText: '{}' }, 'timeout', 'Request timed out', clickedElem);
        }
      }, 15000);
   }

   function guid() {
      return ("0000" + (Math.random() * Math.pow(36, 4) << 0).toString(36)).slice(-4);
   }
   function refreshBundleIds() {
      var b = guid();
      var el = function(id) { return document.getElementById(id); };
      if (el("bundle_id")) el("bundle_id").value = b;
      if (el("gift_id")) el("gift_id").value = b;
      if (el("promo_id")) el("promo_id").value = b;
      if (el("gift_wrapping_id")) el("gift_wrapping_id").value = b;
      if (el("cover_id")) el("cover_id").value = b;
   }

   $(".addtocart").click(function(e){
      e.preventDefault();
      var elem = $(this);
      refreshBundleIds();

      /* Demo terms: require "I agree" checkbox when present */
      var $demoAgree = $('#demoserviceagree');
      if ($demoAgree.length && !$demoAgree.is(':checked')) {
        elem.prop("disabled", false).val('Add to Cart');
        Shopify.showAddToCartError('You must agree to the demo terms before adding to cart.', 'main', true, 'demo-terms');
        return;
      }

      if (window.__productAtcRequiresExplicitChoice && !window.__productVariantExplicitlyChosen) {
        elem.prop("disabled", false).val('Add to Cart');
        if (typeof window.showProductVariantInlineWarning === 'function') {
          window.showProductVariantInlineWarning('Please select an option before adding to cart.');
        } else if (typeof Shopify !== 'undefined' && Shopify.showAddToCartError) {
          var variantErrTarget = (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main';
          Shopify.showAddToCartError('Please select an option before adding to cart.', variantErrTarget, true, 'variant-explicit');
        }
        return;
      }

      if (typeof window.motValidateGiftCardRecipient === 'function' && !window.motValidateGiftCardRecipient()) {
        elem.prop("disabled", false).val('Add to Cart');
        return;
      }

      elem.val('Adding...').prop("disabled", true);

      function doAddToCart(prependItemsOverride) {
        var t = addstring();
        if (t) {
          var productType = document.getElementById("product_type") && document.getElementById("product_type").value;
          var stringServiceType = document.getElementById("stringservicetype") && document.getElementById("stringservicetype").value;
          var prependItems;

          if (prependItemsOverride !== undefined) {
            prependItems = prependItemsOverride;
          } else {
            prependItems = [];
            if (productType === "racquets" && (stringServiceType === "Regular String" || stringServiceType === "Hybrid String")) {
              prependItems = buildStringingItems();
            } else if (productType === "demo-racquet") {
              prependItems = [buildDemoItem()];
            }
          }

          addItem('add-item-form', prependItems.length ? prependItems : null, elem, shopAddLimit);
        } else {
          elem.prop("disabled", false).val('Add to Cart');
        }
      }

      /* Tag-based quantity limit, inventory pre-check, demo service-fee check, and shop add-to-cart limit */
      var $form = $('#add-item-form');
      var limit = parseInt($form.attr('data-quantity-limit') || 0, 10);
      var productId = parseInt($form.attr('data-product-id') || 0, 10);
      var shopAddLimit = parseInt($form.attr('data-shop-add-limit') || 0, 10);
      var mainItem = buildMainItemFromForm('add-item-form');
      var requestedQty = mainItem.quantity || 1;
      if (shopAddLimit > 0 && requestedQty > shopAddLimit) {
        var qtyEl = document.getElementById('quantity');
        if (qtyEl) qtyEl.value = shopAddLimit;
        if (typeof window.syncProductQtyStepperButtons === 'function') window.syncProductQtyStepperButtons();
        requestedQty = shopAddLimit;
        /* When cart is empty, callback won't cap (200 == 200); set message here. Callback overwrites when cart has items. */
        Shopify._pendingLimitMessage = { added: shopAddLimit, limit: shopAddLimit, target: (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main', isShopLimit: true };
      }

      var variantId = parseInt($form.attr('data-variant-id') || 0, 10) || (mainItem.id || 0) || parseInt($('#product-select').val() || 0, 10);
      var inventoryMax = parseInt($form.attr('data-variant-inventory') || 0, 10);
      var inventoryPolicy = ($form.attr('data-inventory-policy') || '').toLowerCase();
      var inventoryMgmt = ($form.attr('data-inventory-management') || '').toLowerCase();

      /* Fallback: get variant inventory from product JSON when form attrs not set (e.g. demo-racquet, multi-option) */
      if (variantId > 0 && (isNaN(inventoryMax) || inventoryPolicy === '' || inventoryMgmt === '')) {
        var variants = (window.Shopify && window.Shopify._productVariants) || [];
        var vidNum = typeof variantId === 'number' ? variantId : parseInt(variantId, 10);
        for (var vi = 0; vi < variants.length; vi++) {
          var vId = variants[vi].id;
          if (vId == vidNum || vId === variantId) {
            var v = variants[vi];
            if (inventoryMgmt === '') inventoryMgmt = (v.inventory_management || '').toLowerCase();
            if (inventoryPolicy === '') inventoryPolicy = (v.inventory_policy || '').toLowerCase();
            if (isNaN(inventoryMax) && v.inventory_quantity != null) inventoryMax = parseInt(v.inventory_quantity, 10);
            break;
          }
        }
      }
      var inventoryCheckNeeded = variantId > 0 && !isNaN(inventoryMax) && inventoryMax >= 0 && inventoryMgmt === 'shopify' && inventoryPolicy !== 'continue';
      var productType = document.getElementById("product_type") && document.getElementById("product_type").value;
      var needsCartForDemoFee = productType === 'demo-racquet';

      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart.js') : '/cart.js';

      if ((limit > 0 && productId > 0) || inventoryCheckNeeded || needsCartForDemoFee || shopAddLimit > 0) {
        var target = (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main';
        $.getJSON(cartUrl, function(cart) {
          var prependOverride;
          if (needsCartForDemoFee) {
            var hasFee = cartHasDemoServiceFee(cart);
            prependOverride = hasFee ? [] : [buildDemoItem()];

            /* Demo racquet: max 1 per variant – allow 1 of each available variant (e.g. different grip/stringing) */
            var demoVariantQty = 0;
            for (var di = 0; di < cart.items.length; di++) {
              if (cart.items[di].variant_id === variantId) demoVariantQty += cart.items[di].quantity;
            }
            if (demoVariantQty >= 1) {
              Shopify.onError({ responseText: JSON.stringify({ description: 'This demo variant is already in your cart.' }) }, 'demo', 'Demo limit', elem);
              return;
            }
          }

          /* Shop limit: already at max – block; would exceed – cap to remaining and add */
          if (shopAddLimit > 0) {
            var variantCartQtyForShop = 0;
            for (var si = 0; si < cart.items.length; si++) {
              if (cart.items[si].variant_id === variantId) variantCartQtyForShop += cart.items[si].quantity;
            }
            if (variantCartQtyForShop >= shopAddLimit) {
              Shopify.onError({
                responseText: JSON.stringify({ description: 'Maximum ' + shopAddLimit + ' per order. You have the maximum in your cart.' })
              }, 'main', 'Shop limit', elem);
              return;
            }
            var shopRemaining = shopAddLimit - variantCartQtyForShop;
            if (requestedQty > shopRemaining) {
              requestedQty = shopRemaining;
              var qtyElShop = document.getElementById('quantity');
              if (qtyElShop) qtyElShop.value = shopRemaining;
              Shopify._pendingLimitMessage = { added: shopRemaining, limit: shopAddLimit, target: target, isShopLimit: true };
            }
          }

          /* Tag-based limit check */
          if (limit > 0 && productId > 0) {
            var cartQty = 0;
            for (var i = 0; i < cart.items.length; i++) {
              if (cart.items[i].product_id === productId) cartQty += cart.items[i].quantity;
            }
            var remaining = limit - cartQty;
            if (remaining <= 0) {
              Shopify.onError({
                responseText: JSON.stringify({ description: 'The maximum quantity of this item is already in your cart.' })
              }, 'limit', 'Quantity limit', elem);
              return;
            }
            if (requestedQty > remaining) {
              var qtyEl = document.getElementById('quantity');
              if (qtyEl) qtyEl.value = remaining;
              if (typeof window.syncProductQtyStepperButtons === 'function') window.syncProductQtyStepperButtons();
              Shopify._pendingLimitMessage = { added: remaining, limit: limit, target: target };
            }
          }

          /* Inventory pre-check: variant stock limit (no overselling). Effective avail = min(inventory, shop limit remaining). When over limit, cap and add with warning (don't block). */
          if (inventoryCheckNeeded) {
            var variantCartQty = 0;
            for (var j = 0; j < cart.items.length; j++) {
              if (cart.items[j].variant_id === variantId) variantCartQty += cart.items[j].quantity;
            }
            var inventoryAvail = inventoryMax - variantCartQty;
            var shopRemaining = shopAddLimit > 0 ? Math.max(0, shopAddLimit - variantCartQty) : inventoryAvail;
            var effectiveAvail = Math.min(inventoryAvail, shopRemaining);
            var totalWouldBe = variantCartQty + requestedQty;
            if (totalWouldBe > inventoryMax || (shopAddLimit > 0 && variantCartQty + requestedQty > shopAddLimit)) {
              if (effectiveAvail <= 0) {
                var msg = shopAddLimit > 0 && variantCartQty >= shopAddLimit
                  ? 'Maximum ' + shopAddLimit + ' per order. You have the maximum in your cart.'
                  : 'Only ' + inventoryMax + ' available. You have the maximum in your cart already.';
                Shopify.onError({ responseText: JSON.stringify({ description: msg }) }, 'inventory', 'Stock limit', elem);
                return;
              }
              /* Cap to effectiveAvail and add with warning */
              requestedQty = effectiveAvail;
              var qtyElInv = document.getElementById('quantity');
              if (qtyElInv) qtyElInv.value = effectiveAvail;
              if (typeof window.syncProductQtyStepperButtons === 'function') window.syncProductQtyStepperButtons();
              Shopify._pendingLimitMessage = { added: effectiveAvail, limit: (inventoryAvail <= shopRemaining ? inventoryMax : shopAddLimit), target: target, isShopLimit: (shopRemaining < inventoryAvail), isInventoryLimit: (inventoryAvail <= shopRemaining) };
            }
          }

          doAddToCart(prependOverride);
        }).fail(function() {
          elem.prop("disabled", false).val('Add to Cart');
          Shopify.onError({ responseText: JSON.stringify({ description: 'Unable to check cart. Please try again.' }) }, 'error', 'Cart error', elem);
        });
      } else {
        doAddToCart();
      }
   });

   /* Dismiss demo-terms error when user checks the box during timeout */
   $(document).on('change', '#demoserviceagree', function() {
      if ($(this).is(':checked') && typeof Shopify !== 'undefined' && Shopify.dismissAddToCartError) {
        Shopify.dismissAddToCartError('demo-terms');
      }
   });

   Shopify.onSuccess = function(response, expectedQty, clickedElem) {
      var elem = (clickedElem && clickedElem.length) ? clickedElem : $('.addtocart');
      if (typeof clearStringingFormErrors === 'function') clearStringingFormErrors();

      /* Use expectedQty when passed (includes prior stringing/demo items), else derive from response */
      var quantity = 1;
      if (expectedQty && expectedQty > 0) {
        quantity = expectedQty;
      } else if (response && response.items && response.items.length) {
        quantity = response.items.reduce(function(sum, item) { return sum + (parseInt(item.quantity, 10) || 0); }, 0);
      } else if (response && (typeof response.quantity === 'number' || response.quantity)) {
        quantity = parseInt(response.quantity, 10) || 1;
      } else {
        quantity = parseInt(jQuery('[name="quantity"]').val(), 10) || 1;
      }

      /* Success feedback: "Added!", colour wipe in, hold 2.5s, wipe out, then restore */
      elem.val('Added!').addClass('addtocart-added-success').prop("disabled", true);
      window.setTimeout(function() {
        elem.addClass('addtocart-removing');
        elem.one('animationend', function() {
          elem.removeClass('addtocart-added-success addtocart-removing').prop("disabled", false).val('Add to Cart');
        });
      }, 2500);

      /* Fetch real cart count and update display */
      var cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? (window.Shopify.routes.root + 'cart.js') : '/cart.js';
      $.getJSON(cartUrl, function(cart) {
        $('#cart-count').text(cart.item_count);
        if (typeof appendCartCountToVariantInventory === 'function') {
          var variantId = parseInt($('#add-item-form').find('[name="id"]').val(), 10);
          appendCartCountToVariantInventory(variantId);
        }
      });

      /* Show limit message and reset quantity if we capped on the add */
      if (Shopify._pendingLimitMessage) {
        var pm = Shopify._pendingLimitMessage;
        Shopify._pendingLimitMessage = null;
        /* Use actual quantity added (never show more than what went to cart) */
        var displayedAdded = Math.min(pm.added, quantity);
        var limitMsg = pm.isShopLimit
          ? 'Only ' + displayedAdded + ' could be added (maximum ' + pm.limit + ' per order).'
          : pm.isInventoryLimit
            ? 'Only ' + displayedAdded + ' could be added (inventory is currently limited to ' + pm.limit + ').'
            : 'Only ' + displayedAdded + ' could be added (limited to ' + pm.limit + ').';
        Shopify.showAddToCartError(limitMsg, pm.target, true);
        var qtyEl = document.getElementById('quantity');
        if (qtyEl) qtyEl.value = 1;
        if (typeof window.syncProductQtyStepperButtons === 'function') window.syncProductQtyStepperButtons();
      }

      /* Run fly-to-cart animation in parallel (non-blocking) */
      function animate() {
        var $cartAnim = $("#cart-animation");
        var $cartTarget = $("#cart-target");
        var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var duration = reduceMotion ? 0 : 800;
        var fadeDuration = reduceMotion ? 0 : 300;

        $cartAnim.text(quantity).show();
        if (reduceMotion) {
          $cartAnim.hide();
          return;
        }
        if (!$cartTarget.length) {
          $cartAnim.hide();
          return;
        }

        /* Hoist to body for this flight: fixed+transform inside sticky/.product__buy-column (or other transformed ancestors) is viewport-rooted incorrectly and clips before the header */
        var cartAnimEl = $cartAnim[0];
        var cartAnimParent = cartAnimEl.parentNode;
        var cartAnimBefore = cartAnimEl.nextSibling;
        $cartAnim.css({ transform: '', left: '', top: '', position: '', willChange: 'auto' });
        document.body.appendChild(cartAnimEl);

        $cartAnim.css('will-change', 'transform');
        var addtocartWidth = elem.outerWidth() / 2;
        var addtocartHeight = elem.outerHeight() / 2;
        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = $(elem).offset().top + addtocartHeight;
        var targetWidth = $cartTarget.outerWidth();
        var buttonAreaLeft = ($cartTarget.offset().left + targetWidth / 2 - $cartAnim.outerWidth() / 2) - 4;
        var buttonAreaTop = ($cartTarget.offset().top + targetWidth / 2 - $cartAnim.outerHeight() / 2) - 4;

        var path = {
          start: { x: addtocartLeft, y: addtocartTop, angle: 190.012, length: 0.2 },
          end: { x: buttonAreaLeft, y: buttonAreaTop, angle: 90.012, length: 0.50 }
        };

        $cartAnim.animate(
          { path: new $.path.bezier(path) },
          duration,
          function() {
            $cartAnim.css('will-change', 'auto');
            $cartAnim.fadeOut(fadeDuration, function() {
              $cartAnim.css({ transform: '', left: '', top: '', position: '' });
              if (cartAnimParent) cartAnimParent.insertBefore(cartAnimEl, cartAnimBefore);
            });
          }
        );
      }
      animate();
    };
  
    /* Unified error display for add-to-cart, quantity limits, and quantity validation. Appends new messages when box is already visible unless replace is true. */
    var _addtocartErrorHideTimeout = null;
    var _addtocartErrorKey = null;
    Shopify.showAddToCartError = function(msg, target, replace, errorKey) {
      target = target || 'main';
      var $mainErr = $('#addtocart-error-main');
      var $stringErr = $('#addtocart-error-stringing');
      var $target = (target === 'stringing' && $stringErr.length) ? $stringErr : $mainErr;
      var $other = (target === 'stringing') ? $mainErr : $stringErr;
      if (!$target.length) return;
      if (_addtocartErrorHideTimeout) { clearTimeout(_addtocartErrorHideTimeout); _addtocartErrorHideTimeout = null; }
      $other.hide().empty().css('display', 'none');
      _addtocartErrorKey = errorKey || null;

      var escapedMsg = (msg + '').replace(/</g, '&lt;');
      var $text = $target.find('.addtocart-error-text').first();
      var isVisible = !replace && $target.css('display') !== 'none' && $text.length;
      var existing = $text.length ? $text.html() : '';
      var isDuplicate = isVisible && existing && (existing === escapedMsg || existing.indexOf(escapedMsg) !== -1);

      if (isVisible && $text.length && !isDuplicate) {
        $text.html(existing + '<br>' + escapedMsg);
      } else if (isDuplicate) {
        /* Same message already shown – just reset the hide timeout, don't stack */
      } else {
        var errHtml = '<i class="fas fa-exclamation-triangle"></i><span class="addtocart-error-text">' + escapedMsg + '</span>';
        $target.html(errHtml).css('display', 'block');
        if (errorKey) $target.attr('data-error-key', errorKey);
      }
      var reduceMotionScroll = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      $target[0].scrollIntoView({ behavior: reduceMotionScroll ? 'auto' : 'smooth', block: 'center', inline: 'nearest' });

      _addtocartErrorHideTimeout = setTimeout(function() {
        $target.fadeOut(300, function() { $(this).empty().removeAttr('data-error-key').css('display', 'none'); _addtocartErrorKey = null; });
        _addtocartErrorHideTimeout = null;
      }, 8000);
    };

    Shopify.dismissAddToCartError = function(onlyIfKey) {
      if (onlyIfKey === 'variant-explicit' && typeof window.hideProductVariantInlineWarning === 'function') {
        window.hideProductVariantInlineWarning();
      }
      if (onlyIfKey && _addtocartErrorKey !== onlyIfKey) return;
      if (_addtocartErrorHideTimeout) { clearTimeout(_addtocartErrorHideTimeout); _addtocartErrorHideTimeout = null; }
      var $mainErr = $('#addtocart-error-main');
      var $stringErr = $('#addtocart-error-stringing');
      [ $mainErr, $stringErr ].forEach(function($el) {
        if ($el.length && (!onlyIfKey || $el.attr('data-error-key') === onlyIfKey)) {
          $el.fadeOut(200, function() { $(this).empty().removeAttr('data-error-key').css('display', 'none'); });
        }
      });
      _addtocartErrorKey = null;
    };

    Shopify.onError = function(xhr, textStatus, errorThrown, clickedElem) {
      var elem = (clickedElem && clickedElem.length) ? clickedElem.first() : $('.addtocart').first();
      elem.prop("disabled", false).val('Add to Cart');

      var data = {};
      try { data = JSON.parse((xhr && xhr.responseText) || '{}'); } catch (e) {}
      var msg = (data && data.description) || (data && data.message) || (data && data.errors) || 'Unable to add to cart. Please try again.';
      if (typeof msg === 'object') msg = (msg.message || msg.description || JSON.stringify(msg));
      if (!(xhr && xhr.responseText) && errorThrown) {
        msg = 'Network error' + (errorThrown ? ': ' + errorThrown : '') + '. Please check your connection and try again.';
      } else if (data && data.message && data.description && data.message !== data.description) {
        msg = data.message + (data.status ? ' (' + data.status + ')' : '') + ': ' + data.description;
      } else if (data && data.message && !data.description) {
        msg = data.message + (data.status ? ' (' + data.status + ')' : '');
      }
      var alt = (Shopify && Shopify.fullMessagesFromErrors) ? Shopify.fullMessagesFromErrors(data) : [];
      if (alt && alt.length && !(data && (data.description || data.message))) { msg = 'Error: ' + alt.join('; '); }

      var target = (elem.hasClass('stringing-addtocart') && $('#addtocart-error-stringing').length) ? 'stringing' : 'main';
      Shopify.showAddToCartError(msg, target);
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      if (!errors || typeof errors !== 'object') return fullMessages;
      jQuery.each(errors, function(attribute, messages) {
        if (Array.isArray(messages)) {
          jQuery.each(messages, function(index, message) {
            fullMessages.push(attribute + ' ' + message);
          });
        } else if (messages != null && typeof messages === 'object') {
          jQuery.each(messages, function(index, message) {
            fullMessages.push(attribute + ' ' + message);
          });
        } else if (attribute !== 'status' && (typeof messages === 'string' || typeof messages === 'number')) {
          fullMessages.push(attribute + ' ' + messages);
        }
      });
      return fullMessages;
    };

  /* PDP product videos: pixel offset for fixed #header (theme --pdp-sticky-top on body.template-product). */
  function _pdpProductVideosHeaderOffsetPx() {
    try {
      var raw = window.getComputedStyle(document.body).getPropertyValue('--pdp-sticky-top').trim();
      if (!raw) return 96;
      var probe = document.createElement('div');
      probe.style.cssText = 'position:absolute;visibility:hidden;left:0;top:0;width:1px;height:' + raw + ';pointer-events:none';
      document.body.appendChild(probe);
      var h = probe.offsetHeight;
      document.body.removeChild(probe);
      if (h > 0) return h;
    } catch (err) {}
    return 96;
  }

  /* Accordion (service_click, review_click): capture phase - slideToggle. Toggle class in callback to avoid CSS fighting animation. */
  document.addEventListener('mousedown', function(e) {
    var header = e.target.closest && e.target.closest('.service_click, .review_click');
    if (!header) return;
    if (header.classList && header.classList.contains('service_click--no-toggle')) return;
    if (e.which !== 1 && e.button !== 0) return;
    e.preventDefault();
    e.stopPropagation();
    var $h = $(header);
    var $content = $h.next();
    var baseDuration = $h.hasClass('club-name-update-toggle') ? 200 : 400;
    var duration = (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 0 : baseDuration;
    if ($h.hasClass('click_opened')) {
      $content.slideUp(duration, function() { $h.removeClass('click_opened').addClass('click_closed'); });
    } else {
      var isPdpProductVideos = header.classList && header.classList.contains('pdp-product-videos__trigger');
      $content.slideDown(duration, function() {
        $h.removeClass('click_closed').addClass('click_opened');
        if (isPdpProductVideos && header.closest) {
          var videosBlock = header.closest('.pdp-product-videos-block');
          if (videosBlock) {
            var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            var headerClear = _pdpProductVideosHeaderOffsetPx();
            var docEl = document.documentElement;
            var curY = window.pageYOffset != null ? window.pageYOffset : (docEl && docEl.scrollTop) || 0;
            var y = videosBlock.getBoundingClientRect().top + curY - headerClear;
            if (y < 0) y = 0;
            try {
              window.scrollTo({ top: y, behavior: reduceMotion ? 'auto' : 'smooth' });
            } catch (err) {
              window.scrollTo(0, y);
            }
          }
        }
      });
    }
  }, true);

  /* PDP product videos trigger: Enter/Space → mousedown (old Safari: initMouseEvent fallback; no MouseEvent / closest). */
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var raw = e.target;
    if (!raw) return;
    var t = null;
    if (raw.closest) {
      t = raw.closest('.pdp-product-videos__trigger.service_click');
    } else {
      var n = raw;
      for (var i = 0; n && i < 12; i++) {
        if (n.classList && n.classList.contains('pdp-product-videos__trigger') && n.classList.contains('service_click')) {
          t = n;
          break;
        }
        n = n.parentElement;
      }
    }
    if (!t || !t.classList || t.classList.contains('service_click--no-toggle')) return;
    e.preventDefault();
    var md;
    try {
      md = new MouseEvent('mousedown', { bubbles: true, cancelable: true, button: 0, buttons: 1, view: window });
    } catch (err) {
      try {
        md = document.createEvent('MouseEvents');
        md.initMouseEvent('mousedown', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      } catch (err2) {
        return;
      }
    }
    t.dispatchEvent(md);
  }, true);

});


jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
    if($(this).attr("value") == "#") return false;
    window.location = $(this).attr("value");
  });

  
});


/*============================*/
/* Update main product image (legacy single-image layout). */
/*============================*/
var switchImage = function(newImageSrc, newImage, mainImageDomEl) {
  jQuery(mainImageDomEl).attr('src', newImageSrc);
  
  jQuery(mainImageDomEl).parent().trigger('zoom.destroy').zoom({ url: newImageSrc.replace('_master', ''), touch: true });
  
};

/*============================*/
/* product.media gallery (images + video + external + 3D) */
/*============================*/
/**
 * Left edge of el relative to ancestor’s content box (offsetParent walk, then getBoundingClientRect fallback).
 */
window._pagerOffsetLeftWithin = function(el, ancestor) {
  if (!el || !ancestor) return 0;
  var left = 0;
  var n = el;
  var guard = 0;
  while (n && n !== ancestor && guard++ < 24) {
    left += n.offsetLeft;
    n = n.offsetParent;
  }
  if (n === ancestor) return left;
  try {
    var er = el.getBoundingClientRect();
    var ar = ancestor.getBoundingClientRect();
    return er.left - ar.left;
  } catch (e) {
    return el.offsetLeft;
  }
};

/**
 * Scroll the pager host so the active thumb is in view (smooth), with padding and a peek of prev/next when possible.
 * Uses scrollTo — avoids scrollIntoView flex/overflow quirks.
 */
window._scrollProductMediaGalleryPagerDotIntoHost = function(dot) {
  if (!dot || typeof dot.closest !== 'function' || typeof dot.parentElement === 'undefined') return;
  var host = dot.closest('.product-media-gallery__pager-host, .product-fs-lightbox__pager-host');
  if (!host) return;
  var strip = dot.parentElement;
  while (strip && !strip.classList.contains('product-media-gallery__pager')) {
    strip = strip.parentElement;
  }
  if (!strip || !strip.classList.contains('product-media-gallery__pager')) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var behavior = reduced ? 'auto' : 'smooth';

  var hostW = host.clientWidth;
  var maxScroll = Math.max(0, host.scrollWidth - hostW);
  if (maxScroll < 1) {
    if (host.scrollLeft !== 0) host.scrollTo({ left: 0, behavior: behavior });
    return;
  }

  var pad = 10;
  var peek = 32;
  var dotL = typeof window._pagerOffsetLeftWithin === 'function' ? window._pagerOffsetLeftWithin(dot, strip) : dot.offsetLeft;
  var dotR = dotL + dot.offsetWidth;
  var lo = dotL - pad;
  var hi = dotR + pad;

  var next = dot.nextElementSibling;
  if (next && next.classList.contains('product-media-gallery__pager-dot')) {
    var nL = typeof window._pagerOffsetLeftWithin === 'function' ? window._pagerOffsetLeftWithin(next, strip) : next.offsetLeft;
    hi = Math.max(hi, nL + Math.min(peek, next.offsetWidth));
  }
  var prev = dot.previousElementSibling;
  if (prev && prev.classList.contains('product-media-gallery__pager-dot')) {
    var pL = typeof window._pagerOffsetLeftWithin === 'function' ? window._pagerOffsetLeftWithin(prev, strip) : prev.offsetLeft;
    var pR = pL + prev.offsetWidth;
    lo = Math.min(lo, pR - Math.min(peek, prev.offsetWidth));
  }
  lo = Math.max(0, lo);
  hi = Math.min(hi, host.scrollWidth);

  var minSl = hi - hostW;
  var maxSl = lo;
  var target;
  if (minSl <= maxSl) {
    target = (minSl + maxSl) / 2;
  } else {
    target = (dotL + dotR) / 2 - hostW / 2;
  }
  target = Math.max(0, Math.min(target, maxScroll));
  host.scrollTo({ left: Math.round(target), behavior: behavior });
};

window.activateProductMediaGalleryIndex = function(index) {
  var root = document.querySelector('#product .product-media-gallery');
  if (!root) return;
  var slides = root.querySelectorAll('.product-media-gallery__slide');
  var dots = root.querySelectorAll('.product-media-gallery__pager-dot');
  if (!slides.length || index < 0 || index >= slides.length) return;

  for (var i = 0; i < slides.length; i++) {
    if (i !== index) {
      slides[i].querySelectorAll('video').forEach(function(v) {
        try { v.pause(); } catch (e) {}
      });
    }
  }

  for (var i = 0; i < slides.length; i++) {
    var on = (i === index);
    slides[i].classList.toggle('is-active', on);
    if (on) slides[i].removeAttribute('hidden');
    else slides[i].setAttribute('hidden', '');
  }
  for (var d = 0; d < dots.length; d++) {
    var di = parseInt(dots[d].getAttribute('data-gallery-index'), 10);
    if (isNaN(di)) di = d;
    var don = (di === index);
    dots[d].classList.toggle('is-active', don);
    dots[d].setAttribute('aria-selected', don ? 'true' : 'false');
    dots[d].setAttribute('tabindex', don ? '0' : '-1');
  }

  root.setAttribute('data-active-index', String(index));

  if (typeof window._updateProductMediaGalleryLoadingState === 'function') {
    window._updateProductMediaGalleryLoadingState(root, slides[index]);
  }

  
  if (typeof jQuery !== 'undefined') {
    var $ = jQuery;
    $(root).find('.product-media-gallery__zoom-target').each(function() {
      var $img = $(this);
      var $par = $img.parent();
      if ($par.length) {
        try { $par.trigger('zoom.destroy'); } catch (err) {}
      }
    });
    var $activeImg = $(slides[index]).find('.product-media-gallery__zoom-target').first();
    if ($activeImg.length) {
      var $parent = $activeImg.parent();
      if (!$parent.is('span.product-media-gallery__zoom-root')) {
        if ($parent.is('span')) {
          $activeImg.unwrap();
        }
        $activeImg.wrap('<span class="product-media-gallery__zoom-root"></span>');
      }
      var $zoomRoot = $activeImg.parent();
      $zoomRoot.removeAttr('style');
      $zoomRoot.addClass('product-media-gallery__zoom-root');
      $activeImg.css('display', 'block');
      var imgEl = $activeImg[0];
      var zs = (imgEl && imgEl.currentSrc) ? imgEl.currentSrc : $activeImg.attr('src');
      if (zs) {
        var zoomUrl = zs.replace('_master', '');
        var zoomIndex = index;
        var zoomGen = (root._productGalleryZoomGen = (root._productGalleryZoomGen || 0) + 1);
        var runZoom = function() {
          if (root._productGalleryZoomGen !== zoomGen) return;
          var cur = parseInt(root.getAttribute('data-active-index'), 10);
          if (isNaN(cur) || cur !== zoomIndex) return;
          var $still = $(slides[zoomIndex]).find('.product-media-gallery__zoom-target').first();
          if (!$still.length || $still.parent()[0] !== $zoomRoot[0]) return;
          $zoomRoot.zoom({ url: zoomUrl, touch: true });
        };
        if (typeof window.requestAnimationFrame === 'function') {
          window.requestAnimationFrame(function() {
            window.requestAnimationFrame(runZoom);
          });
        } else {
          setTimeout(runZoom, 0);
        }
      }
    }
  }
  

  if (typeof window._syncProductMediaGalleryFullscreen === 'function') {
    window._syncProductMediaGalleryFullscreen(root, index);
  }

  (function syncPagerScroll() {
    if (typeof window.requestAnimationFrame !== 'function') {
      setTimeout(function() { window._syncProductMediaGalleryPagerScrollNow(root, index); }, 0);
      return;
    }
    if (root._pagerScrollRafOuter) cancelAnimationFrame(root._pagerScrollRafOuter);
    if (root._pagerScrollRafInner) cancelAnimationFrame(root._pagerScrollRafInner);
    root._pagerScrollRafOuter = requestAnimationFrame(function() {
      root._pagerScrollRafOuter = null;
      root._pagerScrollRafInner = requestAnimationFrame(function() {
        root._pagerScrollRafInner = null;
        window._syncProductMediaGalleryPagerScrollNow(root, index);
      });
    });
  })();
};

/** Fullscreen modal may be moved to document.body so it stacks above fixed #header; keep ref on gallery root. */
window._productMediaGalleryFsModal = function(root) {
  if (!root) return null;
  var el = root._fsLightboxModalEl;
  if (el && document.documentElement.contains(el)) return el;
  el = root.querySelector('.product-fs-lightbox');
  if (el) root._fsLightboxModalEl = el;
  return el;
};

/** Run after layout (zoom, images); scrolls only the visible pager strip (page vs open lightbox). */
window._syncProductMediaGalleryPagerScrollNow = function(root, index) {
  if (!root) return;
  var ix = typeof index === 'number' && !isNaN(index) ? index : parseInt(index, 10);
  if (isNaN(ix) || ix < 0) return;
  if (typeof window._scrollProductMediaGalleryPagerDotIntoHost !== 'function') return;
  var fsModal = window._productMediaGalleryFsModal(root);
  var fsOpen = fsModal && fsModal.classList.contains('is-open') && !fsModal.hasAttribute('hidden');
  var sel = '.product-media-gallery__pager-dot[data-gallery-index="' + ix + '"]';
  if (fsOpen) {
    var mHost = fsModal.querySelector('.product-fs-lightbox__pager-host');
    if (mHost) {
      var mDot = mHost.querySelector(sel);
      if (mDot) window._scrollProductMediaGalleryPagerDotIntoHost(mDot);
    }
  } else {
    var pHost = root.querySelector('.product-media-gallery__controls .product-media-gallery__pager-host');
    if (pHost) {
      var pDot = pHost.querySelector(sel);
      if (pDot) window._scrollProductMediaGalleryPagerDotIntoHost(pDot);
    }
  }
};

/** Keep fullscreen lightbox slides in sync when open (same index as main gallery). */
window._syncProductMediaGalleryFullscreen = function(root, index) {
  if (!root) return;
  var modal = window._productMediaGalleryFsModal(root);
  if (!modal || !modal.classList.contains('is-open')) return;
  var fsSlides = modal.querySelectorAll('.product-fs-lightbox__slide');
  if (!fsSlides.length || index < 0 || index >= fsSlides.length) return;
  for (var i = 0; i < fsSlides.length; i++) {
    var on = (i === index);
    fsSlides[i].classList.toggle('is-active', on);
    if (on) {
      fsSlides[i].removeAttribute('hidden');
    } else {
      fsSlides[i].setAttribute('hidden', '');
      fsSlides[i].querySelectorAll('video').forEach(function(v) {
        try { v.pause(); } catch (e) {}
      });
    }
  }
  /* Modal is under body — pager dots are not under root; mirror activateProductMediaGalleryIndex dot state */
  var fsDots = modal.querySelectorAll('.product-fs-lightbox .product-media-gallery__pager-dot');
  for (var fd = 0; fd < fsDots.length; fd++) {
    var dix = parseInt(fsDots[fd].getAttribute('data-gallery-index'), 10);
    if (isNaN(dix)) dix = fd;
    var dOn = (dix === index);
    fsDots[fd].classList.toggle('is-active', dOn);
    fsDots[fd].setAttribute('aria-selected', dOn ? 'true' : 'false');
    fsDots[fd].setAttribute('tabindex', dOn ? '0' : '-1');
  }
  if (typeof window._updateProductMediaGalleryFullscreenLoadingState === 'function') {
    window._updateProductMediaGalleryFullscreenLoadingState(root, fsSlides[index]);
  }
};

window.openProductMediaGalleryFullscreen = function(root) {
  if (!root) return;
  if (typeof window.matchMedia === 'function' && window.matchMedia('(max-width: 767px)').matches) return;
  var modal = window._productMediaGalleryFsModal(root);
  if (!modal) return;
  root._fsLightboxModalEl = modal;
  modal._productMediaGalleryRoot = root;
  if (modal.parentNode !== document.body) {
    modal._fsLightboxReturnParent = modal.parentNode;
    modal._fsLightboxReturnNext = modal.nextSibling;
    document.body.appendChild(modal);
  }
  root._productFsReturnFocusEl = document.activeElement;
  modal.removeAttribute('hidden');
  modal.classList.add('is-open');
  document.body.classList.add('product-fs-lightbox-open');
  var ix = parseInt(root.getAttribute('data-active-index') || root.getAttribute('data-initial-index') || '0', 10);
  if (typeof window.activateProductMediaGalleryIndex === 'function') {
    window.activateProductMediaGalleryIndex(ix);
  }
  setTimeout(function() {
    var btn = modal.querySelector('.product-fs-lightbox__close');
    if (btn) btn.focus();
  }, 10);
};

window.closeProductMediaGalleryFullscreen = function(root) {
  if (!root) return;
  var modal = window._productMediaGalleryFsModal(root);
  if (!modal) return;
  if (typeof root._fsGalleryImgLoadCleanup === 'function') {
    root._fsGalleryImgLoadCleanup();
    root._fsGalleryImgLoadCleanup = null;
  }
  var loadingEl = modal.querySelector('.product-fs-lightbox__loading');
  var viewport = modal.querySelector('.product-fs-lightbox__viewport');
  if (loadingEl) {
    loadingEl.classList.remove('is-visible');
    loadingEl.hidden = true;
  }
  if (viewport) viewport.removeAttribute('aria-busy');
  modal.classList.remove('is-open');
  modal.setAttribute('hidden', '');
  document.body.classList.remove('product-fs-lightbox-open');
  modal.querySelectorAll('video').forEach(function(v) {
    try { v.pause(); } catch (e) {}
  });
  if (modal._fsLightboxReturnParent) {
    var p = modal._fsLightboxReturnParent;
    var n = modal._fsLightboxReturnNext;
    try {
      if (n && n.parentNode === p) p.insertBefore(modal, n);
      else p.appendChild(modal);
    } catch (e) {
      p.appendChild(modal);
    }
    modal._fsLightboxReturnParent = null;
    modal._fsLightboxReturnNext = null;
  }
  var returnEl = root._productFsReturnFocusEl;
  root._productFsReturnFocusEl = null;
  if (returnEl && typeof returnEl.focus === 'function') {
    try {
      if (returnEl !== document.body && document.documentElement.contains(returnEl)) {
        returnEl.focus();
      } else {
        var fallback = root.querySelector('.product-media-gallery__viewport');
        if (fallback) fallback.focus();
      }
    } catch (err) {}
  }
};

/** Show viewport loading overlay until the active slide's main image has loaded (lazy / slow connections). */
window._updateProductMediaGalleryLoadingState = function(root, activeSlide) {
  var loadingEl = root.querySelector('.product-media-gallery__loading');
  var viewport = root.querySelector('.product-media-gallery__viewport');
  if (!loadingEl || !viewport || !activeSlide) return;

  if (typeof root._galleryImgLoadCleanup === 'function') {
    root._galleryImgLoadCleanup();
    root._galleryImgLoadCleanup = null;
  }

  root._galleryLoadGen = (root._galleryLoadGen || 0) + 1;
  var gen = root._galleryLoadGen;

  function hideLoading() {
    loadingEl.classList.remove('is-visible');
    loadingEl.hidden = true;
    viewport.removeAttribute('aria-busy');
  }

  function finishIfCurrent() {
    if (gen !== root._galleryLoadGen) return;
    hideLoading();
  }

  var img = activeSlide.querySelector('img.product-media-gallery__main-img');
  if (!img) {
    hideLoading();
    return;
  }

  if (img.complete && img.naturalHeight > 0) {
    hideLoading();
    return;
  }

  loadingEl.hidden = false;
  loadingEl.classList.add('is-visible');
  viewport.setAttribute('aria-busy', 'true');

  var onDone = function() {
    img.removeEventListener('load', onDone);
    img.removeEventListener('error', onDone);
    root._galleryImgLoadCleanup = null;
    finishIfCurrent();
  };

  root._galleryImgLoadCleanup = function() {
    img.removeEventListener('load', onDone);
    img.removeEventListener('error', onDone);
    root._galleryImgLoadCleanup = null;
  };

  img.addEventListener('load', onDone);
  img.addEventListener('error', onDone);
};

/** Fullscreen modal: same loading treatment as main gallery for lazy 2048px images. */
window._updateProductMediaGalleryFullscreenLoadingState = function(root, fsActiveSlide) {
  if (!root || !fsActiveSlide) return;
  var modal = window._productMediaGalleryFsModal(root);
  if (!modal || !modal.classList.contains('is-open')) return;
  var loadingEl = modal.querySelector('.product-fs-lightbox__loading');
  var viewport = modal.querySelector('.product-fs-lightbox__viewport');
  if (!loadingEl || !viewport) return;

  if (typeof root._fsGalleryImgLoadCleanup === 'function') {
    root._fsGalleryImgLoadCleanup();
    root._fsGalleryImgLoadCleanup = null;
  }

  root._fsGalleryLoadGen = (root._fsGalleryLoadGen || 0) + 1;
  var gen = root._fsGalleryLoadGen;

  function hideLoading() {
    loadingEl.classList.remove('is-visible');
    loadingEl.hidden = true;
    viewport.removeAttribute('aria-busy');
  }

  function finishIfCurrent() {
    if (gen !== root._fsGalleryLoadGen) return;
    hideLoading();
  }

  var img = fsActiveSlide.querySelector('img.product-fs-lightbox__img');
  if (!img) {
    hideLoading();
    return;
  }

  if (img.complete && img.naturalHeight > 0) {
    hideLoading();
    return;
  }

  loadingEl.hidden = false;
  loadingEl.classList.add('is-visible');
  viewport.setAttribute('aria-busy', 'true');

  var onDone = function() {
    img.removeEventListener('load', onDone);
    img.removeEventListener('error', onDone);
    root._fsGalleryImgLoadCleanup = null;
    finishIfCurrent();
  };

  root._fsGalleryImgLoadCleanup = function() {
    img.removeEventListener('load', onDone);
    img.removeEventListener('error', onDone);
    root._fsGalleryImgLoadCleanup = null;
  };

  img.addEventListener('load', onDone);
  img.addEventListener('error', onDone);
};

jQuery(document).ready(function($){
      
  $("a.zoom").fancybox({
    padding:0,
    'titleShow': false,
    overlayColor: '#000000',
    overlayOpacity: 0.2
  });
  
  var $gal = $('#product .product-media-gallery');
  if ($gal.length) {
    var rootEl = $gal.get(0);
    var advanceGallery = function(galleryRoot, delta) {
      if (!galleryRoot) return;
      var slides = galleryRoot.querySelectorAll('.product-media-gallery__slide');
      if (!slides.length) return;
      var cur = parseInt(galleryRoot.getAttribute('data-active-index') || galleryRoot.getAttribute('data-initial-index') || '0', 10);
      var n = (cur + delta + slides.length) % slides.length;
      if (window.activateProductMediaGalleryIndex) window.activateProductMediaGalleryIndex(n);
    };
    $gal.on('click', '.product-media-gallery__pager-dot', function(e) {
      e.preventDefault();
      var idx = parseInt($(this).attr('data-gallery-index'), 10);
      if (!isNaN(idx) && window.activateProductMediaGalleryIndex) {
        window.activateProductMediaGalleryIndex(idx);
      }
    });
    /* Fullscreen modal is moved under body — controls are outside $gal; delegate from document (only when hoisted to body to avoid double-handling if modal is still in-gallery). */
    $(document).on('click', '.product-fs-lightbox .product-media-gallery__pager-dot', function(e) {
      e.preventDefault();
      var modal = this.closest('.product-fs-lightbox');
      if (!modal || modal.parentNode !== document.body) return;
      var rootFs = modal._productMediaGalleryRoot;
      if (!rootFs || !window.activateProductMediaGalleryIndex) return;
      var idx = parseInt($(this).attr('data-gallery-index'), 10);
      if (!isNaN(idx)) window.activateProductMediaGalleryIndex(idx);
    });
    $gal.on('click', '.product-media-gallery__prev', function(e) {
      e.preventDefault();
      advanceGallery(rootEl, -1);
    });
    $gal.on('click', '.product-media-gallery__next', function(e) {
      e.preventDefault();
      advanceGallery(rootEl, 1);
    });
    $(document).on('click', '.product-fs-lightbox .product-media-gallery__prev', function(e) {
      e.preventDefault();
      var modal = this.closest('.product-fs-lightbox');
      if (!modal || modal.parentNode !== document.body) return;
      var rootFs = modal._productMediaGalleryRoot;
      if (rootFs) advanceGallery(rootFs, -1);
    });
    $(document).on('click', '.product-fs-lightbox .product-media-gallery__next', function(e) {
      e.preventDefault();
      var modal = this.closest('.product-fs-lightbox');
      if (!modal || modal.parentNode !== document.body) return;
      var rootFs = modal._productMediaGalleryRoot;
      if (rootFs) advanceGallery(rootFs, 1);
    });
    $gal.find('.product-media-gallery__viewport').on('keydown', function(ev) {
      if (ev.key === 'ArrowLeft') { advanceGallery(rootEl, -1); ev.preventDefault(); }
      if (ev.key === 'ArrowRight') { advanceGallery(rootEl, 1); ev.preventDefault(); }
    });
    $gal.on('click', 'a.product-media-gallery__lightbox', function(e) {
      e.preventDefault();
      var root = this.closest('.product-media-gallery');
      if (root && window.openProductMediaGalleryFullscreen) {
        window.openProductMediaGalleryFullscreen(root);
      }
    });
    $gal.on('click', '.product-media-gallery__fullscreen', function(e) {
      e.preventDefault();
      var root = this.closest('.product-media-gallery');
      if (root && window.openProductMediaGalleryFullscreen) {
        window.openProductMediaGalleryFullscreen(root);
      }
    });
    /* On-page gallery only ($gal); fullscreen DOM is hoisted under body — see fsGalProtectSel below. */
    var galMediaSel = '.product-media-gallery__viewport img, .product-media-gallery__viewport video, .product-media-gallery__viewport iframe, .product-media-gallery__viewport model-viewer, .product-media-gallery__pager-thumb-img, button.product-media-gallery__pager-thumb';
    $gal.on('contextmenu', galMediaSel, function(e) {
      e.preventDefault();
    });
    $gal.on('dragstart', '.product-media-gallery__viewport img, .product-media-gallery__pager-thumb-img', function(e) {
      e.preventDefault();
    });
    /* Fullscreen modal: delegate from document so hoisted .product-fs-lightbox still blocks context menu / drag on main image and thumbnail strip */
    var fsGalProtectSel = '.product-fs-lightbox img, .product-fs-lightbox video, .product-fs-lightbox iframe, .product-fs-lightbox model-viewer, button.product-media-gallery__pager-thumb';
    $(document).on('contextmenu', fsGalProtectSel, function(e) {
      if (!e.target.closest('.product-fs-lightbox')) return;
      e.preventDefault();
    });
    $(document).on('dragstart', '.product-fs-lightbox img, .product-fs-lightbox .product-media-gallery__pager-thumb-img', function(e) {
      if (!e.target.closest('.product-fs-lightbox')) return;
      e.preventDefault();
    });
    $(document).on('click', '.product-fs-lightbox__backdrop, .product-fs-lightbox__close', function(e) {
      e.preventDefault();
      var modal = this.closest('.product-fs-lightbox');
      if (!modal) return;
      var root = modal._productMediaGalleryRoot || document.querySelector('#product .product-media-gallery');
      if (root && window.closeProductMediaGalleryFullscreen) {
        window.closeProductMediaGalleryFullscreen(root);
      }
    });
    $(document).on('keydown', function productFsLightboxKeys(e) {
      var open = document.querySelector('.product-fs-lightbox.is-open');
      if (!open) return;
      if (e.key === 'Escape') {
        var root = open._productMediaGalleryRoot || document.querySelector('#product .product-media-gallery');
        if (root && window.closeProductMediaGalleryFullscreen) {
          window.closeProductMediaGalleryFullscreen(root);
        }
        return;
      }
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        var rootFs = open._productMediaGalleryRoot || document.querySelector('#product .product-media-gallery');
        if (!rootFs || !window.activateProductMediaGalleryIndex) return;
        var slidesFs = rootFs.querySelectorAll('.product-media-gallery__slide');
        if (!slidesFs.length) return;
        var curFs = parseInt(rootFs.getAttribute('data-active-index') || rootFs.getAttribute('data-initial-index') || '0', 10);
        var delta = (e.key === 'ArrowLeft') ? -1 : 1;
        var n = (curFs + delta + slidesFs.length) % slidesFs.length;
        window.activateProductMediaGalleryIndex(n);
        e.preventDefault();
      }
    });
    var initial = parseInt($gal.attr('data-initial-index') || '0', 10);
    if (window.activateProductMediaGalleryIndex) window.activateProductMediaGalleryIndex(initial);
  } else {
    $('#product .thumbs a').on('click', function(e) { 
      e.preventDefault();
      var main = $('.featured img')[0];
      if (main) switchImage($(this).attr('href'), null, main);
    } );
    
    var mainProductImage = $('.featured img');
    if (mainProductImage.size()) {
      var zoomedSrc = $('.featured img').attr('src').replace('_master', '');
      $('.featured img')
        .wrap('<span style="display:inline-block; max-width: 100%;"></span>')
        .css('display', 'block')
        .parent()
        .zoom({ url: zoomedSrc, touch: true });
    }
    
  }
  
  $("nav.mobile select").change(function(){ window.location = jQuery(this).val(); });

  /* Delegated + jQuery (not $): avoids "…click is not a function" if another script shadows $ or touches jQuery.fn.click */
  jQuery(document).on('click', 'input[type="submit"], input.btn, button', function () {
    jQuery(this).blur();
  });

  /* Product page: when opening prodInfo accordion (mobile) or switching tabs (desktop), scroll so the section title sits below the fixed header */
  (function () {
    var scrollTimer;
    function stickyHeaderOffset() {
      var h = document.getElementById('header');
      if (!h) return 70;
      try {
        return Math.round(h.getBoundingClientRect().height || h.offsetHeight || 70);
      } catch (e) {
        return 70;
      }
    }
    function scrollElBelowHeader(el, opts) {
      if (!el || typeof el.getBoundingClientRect !== 'function') return;
      /* Extra px below fixed header so tab strip / accordion title isn’t tight to the bar */
      var belowHeaderBufferPx = 24;
      var y = el.getBoundingClientRect().top + window.pageYOffset - stickyHeaderOffset() - belowHeaderBufferPx;
      /* Integer scroll top avoids subpixel drift after smooth scroll; reduces “one pixel nudge” on next hover/repaint (sticky PDP). */
      var top = Math.max(0, Math.round(y));
      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var behavior = reduced ? 'auto' : 'smooth';
      if (!reduced && opts && opts.scrollBehavior === 'auto') behavior = 'auto';
      window.scrollTo({ top: top, behavior: behavior });
    }
    function scheduleScrollTo(el, ms, opts) {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () { scrollElBelowHeader(el, opts); }, ms);
    }
    /* PDP: tabs + prodInfoAccordion (activate) scroll section title below fixed header. */
    window.motScheduleScrollToBelowHeader = scheduleScrollTo;
    /* One scroll per tab change: tabsactivate covers click, keyboard, and programmatic .click() (e.g. reviewjump). A second listener on the tab <a> queued overlapping smooth scrolls and caused subtle layout jitter on hover afterward. */
    $(document).on('tabsactivate', '.prodInfoTabs', function () {
      var bar = document.querySelector('.prodInfoTabs ul.tabs');
      if (bar) scheduleScrollTo(bar, 50);
    });
  })();
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;

    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    var scrollX = window.pageXOffset || document.documentElement.scrollLeft || 0;
    var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var x = css.x - scrollX;
    var y = css.y - scrollY;
    var t = 'translate3d(' + x + 'px,' + y + 'px,0)';
    if ( css.prevX != null ) {
      t += ' rotate(' + Math.atan2(css.prevY - css.y, css.prevX - css.x) + 'rad)';
    }
    fx.elem.style.position = 'fixed';
    fx.elem.style.left = '0';
    fx.elem.style.top = '0';
    fx.elem.style.transform = t;
    /* Direct style assignment skips jQuery’s prefix mapping; WebKit needs this for reliable fly-to-cart on older Safari */
    fx.elem.style.webkitTransform = t;
  };
 
})(jQuery);
